<template>
  <div
    :id="id"
    :class="$b()"
  >
    <BaseHeading
      v-if="heading"
      :class="$b('heading')"
      tag="h4"
      size="h2"
    >
      {{ heading }}
    </BaseHeading>

    <ProductData
      :products="productCard.products"
      :lite="true"
    >
      <template #default="{ products }">
        <div :class="$b('product-card')">
          <LiteProductCard
            :product="products"
          />
        </div>
      </template>
    </ProductData>
  </div>
</template>

<script>
export default {
  name: 'ArticleProductCard',

  props: {
    id: {
      type: String,
      required: true
    },
    heading: {
      type: String,
      default: ''
    },
    productCards: {
      type: Array,
      required: true
    }
  },

  computed: {
    productCard () {
      return this.productCards[0]
    }
  }
}
</script>

<style lang="postcss">
.ArticleProductCard__heading {
  @apply mb-sm;
}

.ArticleProductCard__product-card {
  max-width: calc((var(--inner-gutter) * 3 + var(--column-width) * 3));
}
</style>
